import { activities, tours } from "../constants";

// Function to get all reviews for a specific location
export function getReviewsByLocation(locationName) {
  const reviews = [];
  
  // Find all tours with matching location
  const toursInLocation = tours.filter(tour => 
    tour.details.location.toLowerCase() === locationName.toLowerCase()
  );
  
  // Combine all reviews from these tours
  toursInLocation.forEach(tour => {
    if (tour.comments && tour.comments.length > 0) {
      reviews.push(...tour.comments);
    }
  });
  
  return reviews;
}


/**
 * Get all unique activity objects for tours in a specific location
 * @param {string} locationName - The location to filter tours by
 * @returns {Array} Array of unique activity objects, sorted by title
 */
export function getActivitiesByLocation(locationName) {
  const activityNames = new Set();
  
  // Get all unique activity names for the location
  tours.forEach(tour => {
    if (tour.details.location.toLowerCase() === locationName.toLowerCase() && tour.details.activity) {
      tour.details.activity
        .split(',')
        .map(activity => activity.trim())
        .filter(activity => activity)
        .forEach(activity => activityNames.add(activity));
    }
  });
  
  // Convert to array, sort, and map to full activity objects
  return Array.from(activityNames)
    .sort()
    .map(name => activities.find(activity => activity.title === name))
    .filter(activity => activity); // Remove undefined if any activity not found
}